import ProfileNotReadyBanner from './ProfileNotReadyBanner.component';

export default ProfileNotReadyBanner;
